import React from "react";
import TrackVisibility from "react-on-screen";
import CountUp from "react-countup";
import { Link } from "react-router-dom";

const CTAOne = () => {
  return (
    <div className="cta-area-1 space-bottom">
      <div className="container">
        <div className="cta-wrap1">
          <div className="row gy-4 justify-content-md-between align-items-center">
            <div className="col-lg-6 col-md-8">
              <div className="title-area mb-md-0">
                <h2 className="sec-title style2">Let's Do Great! Together</h2>
                <p className="cta-desc text-white mb-0">
                  Reliable Supply, Powerful Solutions.
                </p>
                <p className="cta-desc text-white mb-0">
                  Our References
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="client-box mb-sm-0 mb-5">
                <div className="client-thumb-group mr-30 mb-4" style={{ display: 'flex', justifyContent: 'center' }}>
                  <div className="thumb">
                    <img src="assets/img/client/usa.webp" alt="avater" />
                  </div>
                  <div className="thumb">
                    <img src="assets/img/client/kw.png" alt="avater" />
                  </div>
                  <div className="thumb">
                    <img src="assets/img/client/army2.png" alt="avater" />
                  </div>
                  <div className="thumb">
                    <img src="assets/img/client/tr2.jpg" alt="avater" />
                  </div>
                  <div className="thumb">
                    <img src="assets/img/client/uk.avif" alt="avater" />
                  </div>
                  <div className="thumb icon">
                    <i className="fas fa-plus" />
                  </div>
                </div>

                <div className="client-box-content text-left">
                  <h4 className="cilent-box_counter">
                    <TrackVisibility once>
                      {({ isVisible }) =>
                        isVisible && (
                          <span className="counter-number">
                            <CountUp delay={0} start={0} end={30} />
                            <span> +</span>
                          </span>
                        )
                      }
                    </TrackVisibility>
                  </h4>
                  <span className="cilent-box_title" >References from </span>
                  <span className="cilent-box_title" >Clients Worldwide</span>
                </div>

                {/* Buton */}
                <div className="cta-btn text-center">
                  <Link className="global-btn style-border" to="/contact">
                    contact us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTAOne;